import { getApiUrl } from '../config/api';

/**
 * Wrapper for fetch API that automatically includes Authorization header
 * and handles 401 responses
 */
export const authenticatedFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');

  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(getApiUrl(endpoint), config);

    // Handle 401 Unauthorized
    if (response.status === 401) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');

      if (!window.location.pathname.startsWith('/login') &&
          !window.location.pathname.startsWith('/register')) {
        window.location.href = '/login';
      }

      throw new Error('Unauthorized');
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export default authenticatedFetch;
